import { PromotionStatus, PromotionStatusFilter } from '../types/PromotionTypes';

export const PROMOTION_PAGE_SIZES = [10, 25, 50, 100] as const;

export const PROMOTION_STATUS_OPTIONS: { value: PromotionStatusFilter; label: string }[] = [
  { value: '', label: 'All statuses' },
  { value: 'active_and_not_started', label: 'Active & not started' },
  { value: 'active', label: 'Active' },
  { value: 'not_started', label: 'Not started' },
  { value: 'completed', label: 'Completed' },
  { value: 'disabled', label: 'Disabled' },
];

export const PROMOTION_STATUS_LABELS: Record<PromotionStatus, string> = {
  disabled: 'Disabled',
  not_started: 'Not started',
  active: 'Active',
  completed: 'Completed',
};

export const PROMOTION_STATUS_VARIANTS: Record<PromotionStatus, string> = {
  disabled: 'secondary',
  not_started: 'info',
  active: 'success',
  completed: 'warning',
};

export const REWARDS_PROMO_TYPE_KEY = 'rewards';
export const CONTESTS_PROMO_TYPE_KEY = 'contests';
export const SALES_PROMO_TYPE_KEY = 'sales-events';
export const DISCOVER_SHELVES_PROMO_TYPE_KEY = 'discover-shelves';
export const PROMOTION_IDENTIFIER_MAX_LENGTH = 64;

const SUBCATEGORY_TAG_LABELS: Record<string, string> = {
  [REWARDS_PROMO_TYPE_KEY]: 'reward banner',
  [CONTESTS_PROMO_TYPE_KEY]: 'contest',
  [SALES_PROMO_TYPE_KEY]: 'sale',
  [DISCOVER_SHELVES_PROMO_TYPE_KEY]: 'discover shelf',
};

export function getSubcategoryTitle(
  subcategories: { key: string; title: string; tagLabel?: string }[],
  tagKey: string,
) {
  const entry = subcategories.find((subcategory) => subcategory.key === tagKey);
  return entry?.tagLabel
    ?? SUBCATEGORY_TAG_LABELS[tagKey]
    ?? entry?.title
    ?? tagKey;
}

export function canEditPromotions(toolRole: string | null | undefined) {
  return toolRole === 'editor';
}

export function getPromotionsListUrl(toolKey: string) {
  return `/tools/${toolKey}`;
}
